import type * as React from 'react';
import { useTranslation } from 'react-i18next';
import { LogOut } from 'lucide-react';
import { useAuth } from '@/auth/AuthProvider';
import { LocaleToggle } from '@/components/LocaleToggle';
import { Button } from '@/components/ui/button';
import { Toaster } from '@/components/ui/sonner';
import { Wordmark } from './Wordmark';

/**
 * The whole page when the portal must not load: the brand bar with the language switch and the
 * sign-out, then one card. No navigation at all. Used by the access-paused screen (operator-agency-
 * onboarding, design 2) and the Terms gate (terms-acceptance, design 3).
 */
export function BareLayout({ children }: { children: React.ReactNode }) {
  const { t } = useTranslation();
  const { signOut } = useAuth();

  return (
    <div className="flex min-h-screen flex-col bg-canvas">
      <header className="flex flex-wrap items-center gap-x-6 gap-y-2 bg-rail px-4 py-3 sm:px-6">
        <Wordmark tone="rail" size="sm" layout="inline" />
        <div className="ml-auto flex items-center gap-3">
          <div className="rounded-md bg-card">
            <LocaleToggle />
          </div>
          <Button type="button" variant="outline" size="sm" onClick={() => void signOut()}>
            <LogOut className="size-4" aria-hidden="true" />
            {t('user.signOut')}
          </Button>
        </div>
      </header>
      <main className="flex-1 p-4 sm:p-6">{children}</main>
      <Toaster />
    </div>
  );
}
